module.exports = __webpack_public_path__ + "media/images/icons/country_flags/tj-7342efc96604d64ffb2c8eaf16b89451.svg";